/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react'
import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import EditImg from '../admin/components/editImg'
import { useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import ReactQuill from 'react-quill-new'
import { useDispatch } from 'react-redux'
import { sostituisci } from '../../redux/artista'
import DivBottom from '../userNotAuth/components/divBottom'
import { RotatingLines } from "react-loader-spinner"

function EditArtista() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const artista = location.state?.artista

    const emailUser = localStorage.getItem('email')
    const userId = localStorage.getItem('idUser')

    const [msg, setMsg] = useState({ email: '', foto: null, telefono: null })//messaggio email non valida
    const [validateTipologia, setValidateTipologia] = useState(null)//messaggio campo vuoto in genere
    const [textEmpty, setTextEmpty] = useState(null)//messaggio campo vuoto in descrizione
    const [msgProgress, setMsgProgress] = useState({ string: null, failed: null })//barra del loader dopo submit 
    const [formData, setFormData] = useState({
        fb: artista?.fb,
        id: artista?.id,
        nome: artista?.nome,
        cachet: artista?.cachet,
        cognome: artista?.cognome,
        genere: artista?.genere,
        gruppo: artista?.gruppo,
        incorporaUrl: artista?.incorporaUrl,
        altro: '',
        città: artista?.città,
        idUser: localStorage.getItem('id'),
        flag: false,
        foto: artista?.img,
        regione: artista?.regione,
        numero: artista?.numero,
        durata: artista?.durata,
        descrizione: artista?.descrizione,
        telefono: artista?.telefono,
        email: artista?.emailUser,
        url: artista?.url,
        youtube: artista?.youtube,
        soggetto: artista?.soggetto,
        video: artista?.video,
    })
    const [msgVideo, setMsgVideo] = useState({ videoStateMessage: null })
    const [progressVideo, setProgressVideo] = useState(null)// percentuale di avanzamento upload video
    const [subject, setSubject] = useState({ subject: null, pholder: null, valueSubject: artista?.soggetto })

    const genere = useRef()
    const altro = useRef()// altro genere DIV
    const altroInput = useRef()// altro genere INPUT
    const descrizione = useRef()
    const telefono = useRef()
    const soggetto = useRef()

    function handleChange(e) {
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        setFormData({ ...formData, [name]: inputValue })//valorizzo il name del nuovo oggetto formData 
        setValidateTipologia(null); setTextEmpty(null); setMsg({ email: null, telefono: null }); setMsgProgress({ failed: null })
        genere.current.style.border = '1px solid black'; descrizione.current.style.border = '1px solid black'
        telefono.current.style.border = '1px solid black'
        if (name === 'genere' && value === 'Altro') {
            altro.current.style.display = 'block'
        } else
            if (name === 'genere' && value !== 'Altro' && altro.current.style.display === 'block') {
                altro.current.style.display = 'none'
            }
        if (name === 'altro') { setFormData({ ...formData, genere: inputValue }); return }
        if (name === 'telefono') {
            if (/^[0-9\s-]+$/.test(inputValue) === false && inputValue) { setMsg({ telefono: '*** Campo numerico ***' }); return }
        }
        if (name === 'genere') {
            const ty = document.getElementById("soggetto")
            if (inputValue === 'Acrobata' && name === 'genere') {
                soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Disciplina o numero", pholder: "es: Acrobati dei Tessuti" }); ty.required = true
            } else
                if (inputValue === 'Animatore' && name === 'genere') {
                    soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Tipologia", pholder: "es: Baby dance" }); ty.required = true
                } else
                    if (inputValue === 'Artista di strada' && name === 'genere') {
                        soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Swing band" }); ty.required = true
                    } else
                        if (inputValue === 'Band per tributi' && name === 'genere') {
                            soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Artista tributato", pholder: "es: 883" }); ty.required = true
                        } else
                            if (inputValue === 'Band musica live' && name === 'genere') {
                                soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Cantautorato" }); ty.required = true
                            } else
                                if (inputValue === 'Cantante' && name === 'genere') {
                                    soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Piano bar" }); ty.required = true
                                } else
                                    if (inputValue === 'Circense' && name === 'genere') {
                                        soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Contorsionista" }); ty.required = true
                                    } else
                                        if (inputValue === 'Musicista' && name === 'genere') {
                                            soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Strumento", pholder: "es: Cornamusa" }); ty.required = true
                                        } else
                                            if (inputValue === 'Orchestra' && name === 'genere') {
                                                soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Big band" }); ty.required = true
                                            } else
                                                if (inputValue === 'Spettacolo per bambini' && name === 'genere') {
                                                    soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Gnomi e Fate" }); ty.required = true
                                                } else
                                                    if (inputValue === 'Scuola di ballo' && name === 'genere') {
                                                        soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Salsa merengue" }); ty.required = true
                                                    } else
                                                        if (inputValue === 'Teatro dialettale' && name === 'genere') {
                                                            soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Dialetto", pholder: "es: Pesarese" }); ty.required = true
                                                        }
                                                        else {
                                                            soggetto.current.style.display = 'none'; ty.required = false; ty.value = ''; setSubject({ valueSubject: null })
                                                        }
        }
    }
    function handleDescrizione(e) {
        setFormData({ ...formData, descrizione: e })
        setTextEmpty(formData.descrizione.length)
    }
    async function handleSubmit(e) {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
        if (formData.genere === '') {
            setValidateTipologia('Campo obbligatorio'); window.scrollTo(0, 150)
            genere.current.style.border = '1px solid red'; return
        } else
            if (formData.genere === 'Altro' && formData.altro === '') {
                setValidateTipologia('Campo obbligatorio'); window.scrollTo(0, 150)
                return
            }
        if (formData.descrizione.length < 15 || formData.descrizione.length > 2000) {
            setTextEmpty('Almeno 15 caratteri, max 2000'); window.scrollTo(0, 850)
            descrizione.current.style.border = '1px solid red'; return
        } else
            if (formData.telefono && /^[0-9\s-]+$/.test(formData.telefono) === false) {
                setMsg({ telefono: '*** Campo numerico ***' }); window.scrollTo(0, 750)
                telefono.current.style.border = '1px solid red'; return
            }
        // ---------------- SE TUTTO E' IN CHECK --------------------

        const obj = { ...formData, ...subject }; console.log('obj:', obj)

        try {
            const res = await axios.post(`/updateArtista/${emailUser}`, obj)
            if (res.data === 'Success') {
                dispatch(sostituisci(obj))
                navigate('/editArtistaSuccess')
            } else setMsgProgress({ failed: '*** Problemi con il serever...riprova più tardi ***' })
        } catch (err) { console.log(err) }
    }
    async function videoChange(e) {
        if (e.target.files[0]) {
            const ETarget = e.target.files[0]
            if (ETarget.type.startsWith('video/')) {
                if (ETarget.size > 100000000) {
                    setMsgVideo({ ...msgVideo, videoStateMessage: '*** Video troppo grande...max 100 mega ***' })
                    return
                }
                const v = document.getElementById('progress')
                v.style.width = '94%'; v.style.transition = 'width 40s'; document.getElementById('container').style.border = '1px solid black'
                setMsgVideo({ ...msgVideo, videoStateMessage: 'Attendere...upload video in corso' })
                document.getElementById('rotaryVideo').style.display = 'block'

                // ----------------- controllo durata del video in secondi ----------------
                const videoForDurata = document.createElement('video')
                videoForDurata.src = URL.createObjectURL(ETarget)
                videoForDurata.onloadedmetadata = async function () {
                    const duration = videoForDurata.duration

                    if (duration > 300) {
                        setMsgVideo({ ...msgVideo, videoStateMessage: '*** Video troppo lungo (max 5 min) ***' })
                        window.URL.revokeObjectURL(videoForDurata.src)
                        document.getElementById('rotaryVideo').style.display = 'none'

                    } else {// ------ ACCETTAZIONE VIDEO ---------------------------------------- 
                        let extens = ETarget.name.substring(ETarget.name.lastIndexOf('.') + 1)// ricavo l'estensione  
                        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'// prendi questi caratteri per generare la stringa random
                        let result = ''
                        const charactersLength = characters.length
                        for (let i = 0; i < 15; i++) {
                            result += characters.charAt(Math.floor(Math.random() * charactersLength))
                        }
                        const zxc = `ZE_${result}.${extens}`// aggiungo ZE alla stringa random che darà il nome al video
                        document.getElementById('upload-video').disabled = true

                        function uploadThenSuccess(videoName) {
                            setMsgVideo({ ...msgVideo, videoStateMessage: 'Video caricato con successo' })
                            setFormData({ ...formData, video: videoName }) //formData2.video è il nome che andrà in MYSQL
                            v.style.transition = 'width 0.1s'; v.style.width = '100%'; document.getElementById('container').style.border = '1px solid black'
                            document.getElementById('lblVideo').style.display = 'none' // +video
                            document.getElementById('rotaryVideo').style.display = 'none'
                            document.getElementById('upload-video').disabled = false
                        }
                        function uploadThenFailed() {
                            document.getElementById('rotaryVideo').style.display = 'none'
                            setMsgVideo({ ...msgVideo, videoStateMessage: '*** Problemi con il server...riprova ***' })
                            v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
                            document.getElementById('upload-video').disabled = false
                            document.getElementById('upload-video').value = ''
                        }
                        const fd = new FormData(); let flagCompress

                        if (ETarget.size > 25000000) {//video > 25 mega non lo mando al server Heroku perchè lo saturerebbe in sovraccarico
                            flagCompress = 'compress_off'
                        } else {//video < 25 mega può essere compresso dal server
                            flagCompress = 'compress_on'
                        }
                        fd.append('video', ETarget); fd.append('nomeVideo', zxc); fd.append('stato', 'siAwsBucket')
                        try {
                            const res = await axios.post(`/convertVideo/${flagCompress}`, fd, {
                                headers: { "Content-Type": "multipart/form-data" }
                            })
                            if (res.data === 'success') {
                                if (flagCompress === 'compress_on') uploadThenSuccess(`ZE_${result}.mp4`)
                                if (flagCompress === 'compress_off') uploadThenSuccess(zxc)
                            } else uploadThenFailed()
                        } catch (err) { console.log("Errore durante l'upload", err) }
                    }
                }
            }
            else {// ---------------- video type non conforme ----------------- 
                setMsgVideo({ ...msgVideo, videoStateMessage: '*** Tipo video non conforme ***' })
                e.target.value = ""; return
            }
        }
    }
    async function videoRemove(e) {
        const v = document.getElementById('progress')
        v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
        document.getElementById('upload-video').value = ''
        function removeFadeOut(elment, speed) {
            let seconds = speed / 300
            elment.style.transition = "opacity " + seconds + "s ease"
            elment.style.opacity = 0
            setTimeout(() => {
                setFormData({ ...formData, video: null })
                setTimeout(() => {
                    elment.style.opacity = 1; document.getElementById('lblVideo').style.display = 'block'//visualizzo '+video'  
                }, 50)
            }, speed)
        }
        try {
            axios.delete(`/delete-video/${formData.video}`)
        } catch (err) { setMsgVideo({ ...msgVideo, videoStateMessage: '*** Problemi con la connessione ***' }); console.error(err); return }
        removeFadeOut(document.getElementById('videoPreview'), 200)
        removeFadeOut(document.getElementById('iconaDelVideo'), 200)
        setMsgVideo({ videoStateMessage: null })
    }
    const handleChangeSubject = (e) => {
        const { value } = e.target//attributi degli input
        setSubject({ ...subject, valueSubject: value })
    }
    useEffect(() => {
        if (!genere.current.value) {
            altro.current.style.display = 'block'
            altroInput.current.value = formData.genere
            genere.current.value = 'Altro'
        }
        if (formData.video) document.getElementById('lblVideo').style.display = 'none' // +video
    }, [formData])

    useEffect(() => {
        !userId && navigate('/')
        if (formData.soggetto) {
            const ty = document.getElementById("soggetto")
            soggetto.current.style.display = 'block'; ty.value = formData.soggetto; ty.required = true
            let fg = null
            switch (formData.genere) {
                case "Acrobata": fg = "Disciplina o numero"; break
                case "Band per tributi": fg = "Artista tributato"; break
                case "Band musica live": fg = "Genere"; break
                case "Cantante": fg = "Genere"; break
                case "Circense": fg = "Genere"; break
                case "Musicista": fg = "Strumento"; break
                case "Orchestra": fg = "Genere"; break
                case "Scuola di ballo": fg = "Genere"; break
                case "Teatro dialettale": fg = "Dialetto"; break
                default:
            }
            if (fg) setSubject({ subject: fg })
        }
    }, [])

    return (<>
        <NavbarNotAuth />
        <br /><br />
        <h2 className='m-5'>Modifica artista</h2>
        <div className='container' style={{ marginBottom: '0rem' }}>

            <form onSubmit={handleSubmit}>
                <div> {/*NOME COGNOME*/}
                    <div className="col-md-6"></div>
                    <label htmlFor='nome'>Nome </label>
                    <input className="form-control fw-bold"
                        defaultValue={formData.nome}
                        disabled
                        type="text" />
                    <label htmlFor='cognome' className='mt-3'>Cognome </label>
                    <input className="form-control fw-bold"
                        defaultValue={formData.cognome}
                        disabled
                        type="text" />
                </div>

                <label htmlFor='gruppo' className='mt-3'>Nome gruppo <i style={{ fontSize: 'small' }}>(opzionale)</i></label>
                <input className="form-control fw-bold"
                    name="gruppo"
                    defaultValue={formData.gruppo}
                    maxLength={30}
                    onChange={handleChange}
                    type="text" />

                <label htmlFor='tipologia' className='mt-4'>Tipologia *</label>
                <select className="form-select mt-1 fw-bold" aria-label="Default select example" style={{ width: 'auto' }}
                    name="genere" ref={genere} onChange={handleChange} defaultValue={formData.genere}>
                    <option value=''></option>
                    <option value="Acrobata">Acrobata</option>
                    <option value="Arte del palloncino">Arte del palloncino</option>
                    <option value="Artista di strada">Artista di strada</option>
                    <option value="Artista del fuoco">Artista del fuoco</option>
                    <option value="Band per tributi">Band per tributi</option>
                    <option value="Band musica live">Band musica live</option>
                    <option value="Bolle di sapone">Bolle di sapone</option>
                    <option value="Cabarettista">Cabarettista</option>
                    <option value="Cantante">Cantante</option>
                    <option value="Cartomante">Cartomante</option>
                    <option value="Circense">Circense</option>
                    <option value="Clown">Clown</option>
                    <option value="DJ">DJ</option>
                    <option value="Drag queen">Drag queen</option>
                    <option value="Giocoliere">Giocoliere</option>
                    <option value="Imitatore">Imitatore</option>
                    <option value="Mago">Mago</option>
                    <option value="Mimo">Mimo</option>
                    <option value="Musicista">Musicista</option>
                    <option value="Orchestra">Orchestra</option>
                    <option value="Ritrattista">Ritrattista</option>
                    <option value="Sand artist">Sand artist</option>
                    <option value="Scuola di ballo">Scuola di ballo</option>
                    <option value="Spettacolo pirotecnico">Spettacolo per bambini</option>
                    <option value="Spettacolo pirotecnico">Spettacolo pirotecnico</option>
                    <option value="Statua vivente">Statua vivente</option>
                    <option value="Street artist">Street artist</option>
                    <option value="Teatro burattini">Teatro burattini</option>
                    <option value="Teatro dialettale">Teatro dialettale</option>
                    <option value="Trampoliere">Trampoliere</option>
                    <option value="Truccabimbi">Truccabimbi</option>
                    <option value="Altro">Altro</option>
                </select>
                <div ref={altro} style={{ display: 'none', marginTop: '6px' }}>
                    <label>Inserisci la tipologia dello spettacolo</label>
                    <input className="form-control fw-bold mt-1" ref={altroInput}
                        name="altro"
                        maxLength={40}
                        onChange={handleChange}
                        placeholder='es. Mangiafuoco'
                        type="text" />
                </div>
                {validateTipologia && <p style={{ color: 'red' }}><i>{validateTipologia}</i></p>}

                <div style={{ margin: '1em 0 0 1em', display: 'none' }} ref={soggetto}> {subject.subject} *
                    <input className="form-control" style={{ width: '80%' }} id="soggetto"
                        placeholder={subject.pholder}
                        maxLength={50}
                        name="valueSubject"
                        onChange={handleChangeSubject}
                        type="text" />
                </div>

                <label htmlFor='numero' className='mt-4'>Numero componenti *</label>
                <input className="form-control fw-bold"
                    name="numero" maxLength={50}
                    defaultValue={formData.numero}
                    onChange={handleChange}
                    required
                    type="number" />

                <label htmlFor='città' className='mt-4'>Città </label>
                <input className="form-control fw-bold"
                    name="città"
                    defaultValue={formData.città}
                    maxLength={45}
                    onChange={handleChange}
                    type="text" />

                <label htmlFor='regione' className='mt-4'>Regione </label>
                <input className="form-control fw-bold"
                    name="regione"
                    defaultValue={formData.regione}
                    maxLength={35}
                    onChange={handleChange}
                    type="text" />

                <label htmlFor='durata' className='mt-4'>Durata dello show </label>
                <input className="form-control fw-bold"
                    name="durata"
                    defaultValue={formData.durata}
                    maxLength={30}
                    onChange={handleChange}
                    placeholder='Es. 1 ora e 30 min'
                    type="text" />

                <label htmlFor='cachet' className='mt-4'>Cachet (€) </label>
                <input className="form-control fw-bold"
                    name="cachet"
                    defaultValue={formData.cachet}
                    maxLength={6}
                    onChange={handleChange}
                    placeholder='€'
                    type="text" />

                <h4 style={{ marginTop: '3rem' }}>Descrivi la tua esibizione *</h4>
                <p><i>Ad esempio qualche particolare importante della tua performance di artista...</i></p>
                <div ref={descrizione}>
                    <ReactQuill className="textarea-quill"
                        value={formData.descrizione}
                        theme="snow"
                        onChange={handleDescrizione}
                        placeholder="Es: La band può muoversi in formazione di quattro, cinque membri o full band..."
                        modules={{
                            toolbar: [
                                ['bold', 'italic', 'underline'], // Solo le funzioni base che ti servono
                                ['link'],
                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                ['clean'] // Rimuove la formattazione se l'utente incolla testo sporco
                            ]
                        }}
                    />
                </div>
                {textEmpty && <p style={{ color: 'red' }}><i>{textEmpty}</i></p>}

                <label htmlFor='telefono' className='mt-3'>Telefono<i>(opzionale)</i></label>
                <input className='form-control fw-bold' ref={telefono}
                    name='telefono'
                    defaultValue={formData.telefono}
                    maxLength={20}
                    onChange={handleChange}
                    type='text'
                />
                {msg.telefono && <p style={{ color: 'red' }}><i>{msg.telefono}</i></p>}

                <h5 style={{ fontFamily: 'sans-serif', marginTop: '3rem' }}>LINK</h5>
                <div style={{ marginLeft: '1rem' }}>
                    <label htmlFor='email' className='mt-1'>URL sito web</label>
                    <input className="form-control"
                        name="url"
                        defaultValue={formData.url}
                        maxLength={250}
                        onChange={handleChange}
                        placeholder='es: https://www.zona-eventi.it/'
                        type="text" />

                    <label htmlFor='email' className='mt-3'>URL Facebook</label>
                    <input className="form-control"
                        name="fb"
                        defaultValue={formData.fb}
                        maxLength={250}
                        onChange={handleChange}
                        placeholder='es: https://www.facebook.com/'
                        type="text" />

                    <label htmlFor='email' className='mt-3'>URL YouTube</label>
                    <input className="form-control"
                        name="youtube"
                        defaultValue={formData.youtube}
                        maxLength={250}
                        onChange={handleChange}
                        placeholder='es: https://www.youtube.com/'
                        type="text" />
                </div>

                <label htmlFor='email' className='mt-3'>Email *</label>
                <input className="form-control"
                    defaultValue={formData.email}
                    type="text" />
                {/* --------------------------- AGGIUNGI IMMAGINE ------------------ */}
                <EditImg folder={''} numero={[0]} imgOld={artista.img} invioFoto={(e) => { setFormData({ ...formData, foto: e.join(',') }) }} />

                {/* --------------------------- Incorpora Video ------------------ */}
                <div className='mt-5'>
                    <p className='fs-6'>INCORPORA UN VIDEO DA YOUTUBE
                        <span style={{ fontSize: 'x-small', backgroundColor: 'maroon', color: 'white', borderRadius: '5px', marginLeft: '1em', padding: '5px', cursor: 'pointer' }}
                            onClick={() => {
                                document.getElementById('esempioIncorp').style.display = 'block'; setTimeout(() => {
                                    document.getElementById('esempioIncorp').style.display = 'none'
                                }, 15000)
                            }}
                        >esempio
                        </span>
                    </p>
                    <input className="form-control"
                        defaultValue={formData.incorporaUrl}
                        name='incorporaUrl'
                        onChange={handleChange}
                        placeholder='URL del video'
                        type='text' />
                    <div id='esempioIncorp' style={{
                        border: '1px solid grey', width: '40%', height: '220px', position: 'absolute', backgroundColor: 'whitesmoke', left: '14em',
                        fontSize: 'small', padding: '10px', display: 'none'
                    }}>
                        <img src={require('../userNotAuth/image/icons8-chiudi-macos-32.png')} style={{ cursor: 'pointer' }} alt=''
                            onClick={() => { document.getElementById('esempioIncorp').style.display = 'none' }} />
                        Sopra al video di YouTube clicca con il tasto destro del mouse e seleziona <i>Copia URL Video</i>. Poi incolla l'URL appena copiato nel campo <i>URL del video</i> qui sopra.
                    </div>
                </div>

                <div>
                    <h4 style={{ marginTop: '2em' }}>AGGIUNGI VIDEO (max 5 min)</h4>
                    <p style={{ opacity: '.7' }}><i>*** opzionale ***</i></p>
                    <div style={{ border: '2px solid cornflowerblue', width: '200px', height: '130px', textAlign: 'center', margin: '2em 0 0 0', borderRadius: '5px' }}>
                        <label htmlFor="upload-video" style={{ cursor: 'pointer' }} id='lblVideo'>
                            + Video
                            <span id="rotaryVideo" style={{ display: 'none' }}>
                                <RotatingLines strokeColor='black' strokeWidth='5' animationDuration='5' width='26' />
                            </span>
                        </label>
                        {formData.video &&
                            <div>
                                <div style={{ marginTop: '-27px' }}>
                                    <button style={{ marginLeft: '10rem', border: 'transparent', backgroundColor: 'transparent' }}
                                        onClick={videoRemove} id={'iconaDelVideo'} type='button'>
                                        ❌
                                    </button>
                                </div>
                                <div>
                                    {/* ------------- preview del video proveniente da MYSQL ------------ */}
                                    <video src={`https://leuro-bucket.s3.amazonaws.com/video/${formData.video}`} id={'videoPreview'}
                                        style={{ width: '198px', height: '128px', borderRadius: '5px' }} controls />
                                </div>
                            </div>
                        }
                        <input id='upload-video' style={{ opacity: '0', fontSize: '0px' }}
                            type='file'
                            name='video'
                            accept="video/*"
                            onChange={videoChange} />
                    </div>
                    {/* ------------ barra di avanzamento ----------------------- */}
                    <div style={{ width: '35%', backgroundColor: 'transparent', marginTop: '1em' }} id='container'>
                        <div style={{ width: '0', height: '10px', backgroundColor: 'darkturquoise' }} id='progress'>
                        </div>
                    </div>
                    {msgVideo.videoStateMessage &&
                        <p style={{ color: 'navy' }}><i>{msgVideo.videoStateMessage} {progressVideo}</i></p>
                    }

                </div>
                {msgProgress.string &&
                    <h5 className='mt-3'>
                        <RotatingLines strokeColor='navy' strokeWidth='5' animationDuration='5' width='26' />
                        <span style={{ marginLeft: '1rem', color: 'navy' }}>{msgProgress.string}</span>
                    </h5>}

                {msgProgress.failed && <p style={{ color: 'red', marginTop: '1rem' }}>{msgProgress.failed}</p>}

                <hr />

                <p className='mt-5'><i>* campi obbligatori</i></p>
                <button type='button' className='btn btn-secondary mt-5'
                    onClick={() => {
                        navigate('/profiloArtista', { replace: true, })
                    }}>Indietro
                </button>
                <button type='submit' className='btn btn-primary mt-5' style={{ marginLeft: '1rem' }}>Avanti</button>
            </form>
        </div>
        <DivBottom />
    </>)
}
export default EditArtista